
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[productId]/exchange-refund-guide",
      function () {
        return require("private-next-pages/products/[productId]/exchange-refund-guide.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[productId]/exchange-refund-guide"])
      });
    }
  